'use client';

import React from 'react';
import Link from 'next/link';
import { Check } from 'lucide-react';

const reassurances = [
  { id: 'reassurance-confidence', text: 'Build real AI confidence — at your own pace.' },
  { id: 'reassurance-payment', text: 'One payment. Lifetime access to the platform.' },
  { id: 'reassurance-cheatsheet', text: 'AI Cheat Sheet and future updates included.' },
];

export default function FinalCTA() {
  return (
    <section
      className="py-24 lg:py-36"
      style={{ backgroundColor: 'var(--navy)' }}
      aria-label="Get full access"
    >
      <div className="max-w-screen-xl mx-auto px-6 lg:px-12 xl:px-20 text-center">
        {/* Eyebrow */}
        <p
          className="font-body text-xs uppercase tracking-widest mb-6"
          style={{ color: 'var(--amber)', letterSpacing: '0.12em' }}
        >
          Get Full Access
        </p>

        <h2
          className="font-display font-semibold mb-8"
          style={{
            fontSize: 'clamp(2rem, 4vw, 3.25rem)',
            color: 'white',
            lineHeight: '1.2',
          }}
        >
          Everything you need.
          <br />
          <span style={{ color: 'var(--amber)' }}>Nothing you don&rsquo;t.</span>
        </h2>

        <p
          className="font-body text-base lg:text-lg mb-12 max-w-xl mx-auto"
          style={{ color: 'rgba(255,255,255,0.65)', lineHeight: '1.8' }}
        >
          Your confidence with AI starts here. Nine modules, a downloadable cheat sheet, and all future updates to the core platform.
          One payment. No subscription. No renewal.
        </p>

        {/* Price */}
        <div className="inline-flex flex-col items-center mb-10">
          <div className="flex items-baseline gap-3 mb-2">
            <span
              className="font-body text-sm line-through"
              style={{ color: 'rgba(255,255,255,0.35)' }}
            >
              $79
            </span>
            <span
              className="font-display font-semibold text-5xl"
              style={{ color: 'white' }}
            >
              $67
            </span>
          </div>
          <p
            className="font-body text-xs italic"
            style={{ color: 'rgba(255,255,255,0.45)' }}
          >
            15% off for joining now. No code needed.
          </p>
        </div>

        {/* CTA button */}
        <div className="flex flex-col items-center gap-5">
          <Link
            href="/conversion-page"
            className="inline-flex items-center gap-2.5 font-body font-semibold text-base px-10 py-4 rounded-xl transition-all duration-200 active:scale-95 shadow-amber-glow"
            style={{ backgroundColor: 'var(--amber)', color: 'white' }}
          >
            Get Full Access — $67
          </Link>
          <Link
            href="/free-lesson-screen"
            className="font-body text-sm transition-colors duration-150 hover:opacity-70"
            style={{ color: 'rgba(255,255,255,0.45)' }}
          >
            Start with the free lessons first
          </Link>
        </div>

        {/* Reassurance strip */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          {reassurances?.map((item) => (
            <div key={item?.id} className="flex items-center gap-2.5">
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgba(212, 137, 26, 0.2)', border: '1px solid rgba(212, 137, 26, 0.4)' }}
              >
                <Check size={11} style={{ color: 'var(--amber)' }} aria-hidden="true" />
              </div>
              <span className="font-body text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>
                {item?.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}